exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".resultlist-top-div {\n    margin-top: 2.15em;\n}\n\n.resultlist-page-link {\n    color: rgba(0, 0, 0, 4);\n    border: 0;\n}\n\n.resultlist-page-link:hover {\n    color: rgba(0, 0, 0, 4);\n    border: 0;\n}\n\n.scroll {\n    position: fixed;\n    bottom: 30px;\n    right: 70px;\n}", ""]);

